import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M45.4493 32L0 32L0 0L45.4493 0L56 16L45.4493 32Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 32

/**
 * Tag Right shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const TagRightShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default TagRightShape
